import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ReportRow } from '@/api/routes/reports/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchReports } from './actionCreators';

interface InitialState {
    reports: ReportRow [],
    prevReports: ReportRow [],
    offset: number,
    totalCount: number,
    prevTotalCount: number,
    isLoading: boolean,
    error: string,
}

const initialState: InitialState = {
  reports: [],
  prevReports: [],
  offset: 0,
  totalCount: 0,
  prevTotalCount: 0,
  isLoading: false,
  error: '',
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    toggleReportsEnabled: (state, action: PayloadAction<string>) => {
      const index = state.reports.findIndex((el) => el.id === action.payload);
      state.reports[index].enabled = !state.reports[index].enabled;
    },
  },
  extraReducers: {
    [fetchReports.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<ReportRow>>) => {
      state.isLoading = false;
      state.error = '';
      state.prevReports = state.reports;
      state.reports = action.payload.rows;
      state.offset = action.payload.offset;
      state.prevTotalCount = state.totalCount;
      state.totalCount = action.payload.total_count;
    },
    [fetchReports.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchReports.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  toggleReportsEnabled,
} = reportsSlice.actions;
export default reportsSlice.reducer;
